@use "variables" as *;

.title {
  font-size: $fontSize-m;
  padding-top: 6px;
  align-self: center;
}

.tableDiv {
  padding: $spacing-s calc(#{$spacing-s} + #{$spacing-m}) $spacing-l
    calc(#{$spacing-s} + #{$spacing-m});
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.header {
  margin-bottom: $spacing-s;
}

.noLocationText {
  font-size: $fontSize-s;
  align-self: center;
  justify-self: center;
  text-align: center;
  width: 100%;
  margin: $spacing-xl $spacing-m;
}

.skeleton {
  width: 100%;
  height: 44px !important;
  border-radius: 8px;
  margin-top: $spacing-m;
  margin-bottom: $spacing-m;
}
